import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';

export function configureLocales(): void {
  registerLocaleData(localeEs, 'es');
  registerLocaleData(localeEn, 'en');
}

